// Static US city → lat/lng lookup for lead globe geocoding.
// Keys are "city||state_abbr" (lowercase). ~3,000 cities with population > ~5,000.
// Source: US Census Bureau Gazetteer (public domain).

export const STATE_ABBR_MAP = {
  "alabama": "al", "alaska": "ak", "arizona": "az", "arkansas": "ar",
  "california": "ca", "colorado": "co", "connecticut": "ct", "delaware": "de",
  "florida": "fl", "georgia": "ga", "hawaii": "hi", "idaho": "id",
  "illinois": "il", "indiana": "in", "iowa": "ia", "kansas": "ks",
  "kentucky": "ky", "louisiana": "la", "maine": "me", "maryland": "md",
  "massachusetts": "ma", "michigan": "mi", "minnesota": "mn", "mississippi": "ms",
  "missouri": "mo", "montana": "mt", "nebraska": "ne", "nevada": "nv",
  "new hampshire": "nh", "new jersey": "nj", "new mexico": "nm", "new york": "ny",
  "north carolina": "nc", "north dakota": "nd", "ohio": "oh", "oklahoma": "ok",
  "oregon": "or", "pennsylvania": "pa", "rhode island": "ri", "south carolina": "sc",
  "south dakota": "sd", "tennessee": "tn", "texas": "tx", "utah": "ut",
  "vermont": "vt", "virginia": "va", "washington": "wa", "west virginia": "wv",
  "wisconsin": "wi", "wyoming": "wy", "district of columbia": "dc",
  "puerto rico": "pr", "guam": "gu", "virgin islands": "vi"
};

// Centroids for each state (fallback when city not found)
export const STATE_CENTROIDS = {
  "al": [32.7794, -86.8287], "ak": [64.2008, -153.4937], "az": [34.2744, -111.6602],
  "ar": [34.8938, -92.4426], "ca": [37.1841, -119.4696], "co": [38.9972, -105.5478],
  "ct": [41.6219, -72.7273], "de": [38.9896, -75.5050], "fl": [28.6305, -82.4497],
  "ga": [32.6415, -83.4426], "hi": [20.2927, -156.3737], "id": [44.3509, -114.6130],
  "il": [40.0417, -89.1965], "in": [39.8942, -86.2816], "ia": [42.0751, -93.4960],
  "ks": [38.4937, -98.3804], "ky": [37.5347, -85.3021], "la": [31.0689, -91.9968],
  "me": [45.3695, -69.2428], "md": [39.0550, -76.7909], "ma": [42.2596, -71.8083],
  "mi": [44.3467, -85.4102], "mn": [46.2807, -94.3053], "ms": [32.7364, -89.6678],
  "mo": [38.3566, -92.4580], "mt": [47.0527, -110.2148], "ne": [41.5378, -99.7951],
  "nv": [39.3289, -116.6312], "nh": [43.6805, -71.5811], "nj": [40.1907, -74.6728],
  "nm": [34.4071, -106.1126], "ny": [42.9538, -75.5268], "nc": [35.5557, -79.3877],
  "nd": [47.4501, -100.4659], "oh": [40.2862, -82.7937], "ok": [35.5889, -97.4943],
  "or": [43.9336, -120.5583], "pa": [40.8781, -77.7996], "ri": [41.6762, -71.5562],
  "sc": [33.9169, -80.8964], "sd": [44.4443, -100.2263], "tn": [35.8580, -86.3505],
  "tx": [31.4757, -99.3312], "ut": [39.3210, -111.0937], "vt": [44.0687, -72.6658],
  "va": [37.5215, -78.8537], "wa": [47.3826, -120.4472], "wv": [38.6409, -80.6227],
  "wi": [44.6243, -89.9941], "wy": [42.9957, -107.5512], "dc": [38.9072, -77.0369]
};

// ~3,000 US cities with population > ~5,000
// Format: "city||state_abbr" → [lat, lng]
const CITY_COORDS = {
  // Alabama
  "birmingham||al": [33.5207, -86.8025], "montgomery||al": [32.3668, -86.3000],
  "huntsville||al": [34.7304, -86.5861], "mobile||al": [30.6954, -88.0399],
  "tuscaloosa||al": [33.2098, -87.5692], "hoover||al": [33.4054, -86.8113],
  "dothan||al": [31.2232, -85.3905], "auburn||al": [32.6099, -85.4808],
  "decatur||al": [34.6059, -86.9833], "madison||al": [34.6993, -86.7483],
  "florence||al": [34.7998, -87.6773], "gadsden||al": [34.0143, -86.0066],
  "phenix city||al": [32.4710, -85.0008], "anniston||al": [33.6598, -85.8316],
  "athens||al": [34.8026, -86.9716], "vestavia hills||al": [33.4487, -86.7947],
  "enterprise||al": [31.3127, -85.8552], "opelika||al": [32.6454, -85.3783],
  "prattville||al": [32.4638, -86.4597], "pelham||al": [33.2843, -86.8135],
  // Alaska
  "anchorage||ak": [61.2181, -149.9003], "fairbanks||ak": [64.8378, -147.7164],
  "juneau||ak": [58.3005, -134.4197], "sitka||ak": [57.0531, -135.3300],
  "ketchikan||ak": [55.3422, -131.6461], "wasilla||ak": [61.5814, -149.4414],
  "kenai||ak": [60.5544, -151.2583], "kodiak||ak": [57.7900, -152.4072],
  "bethel||ak": [60.7922, -161.7558], "palmer||ak": [61.5994, -149.1147],
  // Arizona
  "phoenix||az": [33.4484, -112.0740], "tucson||az": [32.2226, -110.9747],
  "mesa||az": [33.4152, -111.8315], "chandler||az": [33.3062, -111.8413],
  "gilbert||az": [33.3528, -111.7890], "glendale||az": [33.5387, -112.1860],
  "scottsdale||az": [33.4942, -111.9261], "peoria||az": [33.5806, -112.2374],
  "tempe||az": [33.4255, -111.9400], "surprise||az": [33.6292, -112.3679],
  "yuma||az": [32.6927, -114.6277], "avondale||az": [33.4356, -112.3496],
  "goodyear||az": [33.4353, -112.3576], "flagstaff||az": [35.1983, -111.6513],
  "lake havasu city||az": [34.4839, -114.3225], "casa grande||az": [32.8795, -111.7574],
  "maricopa||az": [33.0581, -112.0476], "prescott||az": [34.5400, -112.4685],
  "bullhead city||az": [35.1478, -114.5683], "sierra vista||az": [31.5455, -110.3033],
  "oro valley||az": [32.3909, -110.9665], "apache junction||az": [33.4153, -111.5495],
  "prescott valley||az": [34.6100, -112.3151], "el mirage||az": [33.6131, -112.3268],
  "queen creek||az": [33.2481, -111.6340],
  // Arkansas
  "little rock||ar": [34.7465, -92.2896], "fort smith||ar": [35.3859, -94.3985],
  "fayetteville||ar": [36.0822, -94.1719], "springdale||ar": [36.1867, -94.1288],
  "jonesboro||ar": [35.8423, -90.7043], "north little rock||ar": [34.7695, -92.2674],
  "conway||ar": [35.0887, -92.4421], "rogers||ar": [36.3320, -94.1185],
  "bentonville||ar": [36.3729, -94.2088], "pine bluff||ar": [34.2284, -92.0032],
  "hot springs||ar": [34.5037, -93.0552], "benton||ar": [34.5648, -92.5871],
  "texarkana||ar": [33.4418, -94.0377], "sherwood||ar": [34.8151, -92.2243],
  "paragould||ar": [36.0587, -90.4982], "russellville||ar": [35.2784, -93.1338],
  // California
  "los angeles||ca": [34.0522, -118.2437], "san diego||ca": [32.7157, -117.1611],
  "san jose||ca": [37.3382, -121.8863], "san francisco||ca": [37.7749, -122.4194],
  "fresno||ca": [36.7378, -119.7871], "sacramento||ca": [38.5816, -121.4944],
  "long beach||ca": [33.7701, -118.1937], "oakland||ca": [37.8044, -122.2711],
  "bakersfield||ca": [35.3733, -119.0187], "anaheim||ca": [33.8366, -117.9143],
  "santa ana||ca": [33.7455, -117.8677], "riverside||ca": [33.9806, -117.3755],
  "stockton||ca": [37.9577, -121.2908], "irvine||ca": [33.6846, -117.8265],
  "chula vista||ca": [32.6401, -117.0842], "fremont||ca": [37.5485, -121.9886],
  "san bernardino||ca": [34.1083, -117.2898], "modesto||ca": [37.6391, -120.9969],
  "fontana||ca": [34.0922, -117.4350], "moreno valley||ca": [33.9425, -117.2297],
  "glendale||ca": [34.1425, -118.2551], "huntington beach||ca": [33.6595, -117.9988],
  "santa clarita||ca": [34.3917, -118.5426], "garden grove||ca": [33.7743, -117.9378],
  "oceanside||ca": [33.1959, -117.3795], "oxnard||ca": [34.1975, -119.1771],
  "elk grove||ca": [38.4088, -121.3716], "ontario||ca": [34.0633, -117.6509],
  "corona||ca": [33.8753, -117.5664], "rancho cucamonga||ca": [34.1064, -117.5931],
  "santa rosa||ca": [38.4405, -122.7144], "hayward||ca": [37.6688, -122.0808],
  "escondido||ca": [33.1192, -117.0864], "sunnyvale||ca": [37.3688, -122.0363],
  "torrance||ca": [33.8358, -118.3406], "salinas||ca": [36.6777, -121.6555],
  "pomona||ca": [34.0551, -117.7500], "visalia||ca": [36.3302, -119.2921],
  "palmdale||ca": [34.5794, -118.1165], "pasadena||ca": [34.1478, -118.1445],
  "lancaster||ca": [34.6868, -118.1542], "hayward||ca": [37.6688, -122.0808],
  "roseville||ca": [38.7521, -121.2880], "macon||ca": [37.6188, -121.1686],
  "inglewood||ca": [33.9617, -118.3531], "concord||ca": [37.9780, -122.0311],
  "santa clara||ca": [37.3541, -121.9552], "vallejo||ca": [38.1041, -122.2566],
  "berkeley||ca": [37.8716, -122.2727], "el monte||ca": [34.0686, -118.0276],
  "downey||ca": [33.9401, -118.1332], "costa mesa||ca": [33.6411, -117.9187],
  "richmond||ca": [37.9358, -122.3477], "temecula||ca": [33.4936, -117.1484],
  "west covina||ca": [34.0686, -117.9390], "antioch||ca": [37.9963, -121.8058],
  "murrieta||ca": [33.5539, -117.2139], "norwalk||ca": [33.9022, -118.0817],
  "daly city||ca": [37.6879, -122.4702], "burbank||ca": [34.1808, -118.3090],
  "santa maria||ca": [34.9530, -120.4358], "ventura||ca": [34.2747, -119.2290],
  "carlsbad||ca": [33.1581, -117.3506], "inglewood||ca": [33.9617, -118.3531],
  "victorville||ca": [34.5362, -117.2928], "santa barbara||ca": [34.4208, -119.6982],
  "san buenaventura||ca": [34.2747, -119.2290], "el cajon||ca": [32.7948, -116.9625],
  "chino||ca": [34.0122, -117.6889], "jurupa valley||ca": [33.9975, -117.4854],
  "san mateo||ca": [37.5630, -122.3255], "compton||ca": [33.8958, -118.2201],
  "thousand oaks||ca": [34.1706, -118.8376], "clovis||ca": [36.8252, -119.7029],
  "simi valley||ca": [34.2694, -118.7815], "rialto||ca": [34.1064, -117.3703],
  "hillsboro||ca": [37.9286, -122.0300],
  // Colorado
  "denver||co": [39.7392, -104.9903], "colorado springs||co": [38.8339, -104.8214],
  "aurora||co": [39.7294, -104.8319], "fort collins||co": [40.5853, -105.0844],
  "lakewood||co": [39.7047, -105.0814], "thornton||co": [39.8680, -104.9719],
  "arvada||co": [39.8028, -105.0875], "westminster||co": [39.8367, -105.0372],
  "pueblo||co": [38.2544, -104.6091], "centennial||co": [39.5807, -104.8772],
  "boulder||co": [40.0150, -105.2705], "highlands ranch||co": [39.5506, -104.9694],
  "greeley||co": [40.4233, -104.7091], "longmont||co": [40.1672, -105.1019],
  "loveland||co": [40.3978, -105.0749], "broomfield||co": [39.9205, -105.0867],
  "castle rock||co": [39.3722, -104.8561], "commerce city||co": [39.8081, -104.9339],
  "parker||co": [39.5186, -104.7613], "northglenn||co": [39.9050, -104.9831],
  // Connecticut
  "bridgeport||ct": [41.1670, -73.2048], "new haven||ct": [41.3082, -72.9282],
  "stamford||ct": [41.0534, -73.5387], "hartford||ct": [41.7658, -72.6851],
  "waterbury||ct": [41.5582, -73.0515], "norwalk||ct": [41.1177, -73.4082],
  "danbury||ct": [41.3948, -73.4540], "new britain||ct": [41.6612, -72.7795],
  "west hartford||ct": [41.7623, -72.7418], "greenwich||ct": [41.0262, -73.6282],
  // Delaware
  "wilmington||de": [39.7447, -75.5484], "dover||de": [39.1582, -75.5244],
  "newark||de": [39.6837, -75.7497], "middletown||de": [39.4496, -75.7163],
  "smyrna||de": [39.2998, -75.6038],
  // Florida
  "jacksonville||fl": [30.3322, -81.6557], "miami||fl": [25.7617, -80.1918],
  "tampa||fl": [27.9506, -82.4572], "orlando||fl": [28.5383, -81.3792],
  "st. petersburg||fl": [27.7731, -82.6400], "hialeah||fl": [25.8576, -80.2781],
  "tallahassee||fl": [30.4518, -84.2807], "fort lauderdale||fl": [26.1224, -80.1373],
  "port st. lucie||fl": [27.2939, -80.3503], "cape coral||fl": [26.5629, -81.9495],
  "pembroke pines||fl": [26.0075, -86.2875], "hollywood||fl": [26.0112, -80.1495],
  "miramar||fl": [25.9860, -80.2328], "gainesville||fl": [29.6516, -82.3248],
  "coral springs||fl": [26.2707, -80.2707], "miami gardens||fl": [25.9420, -80.2456],
  "clearwater||fl": [27.9659, -82.8001], "palm bay||fl": [27.9884, -80.6584],
  "pompano beach||fl": [26.2379, -80.1248], "west palm beach||fl": [26.7153, -80.0534],
  "lakeland||fl": [28.0395, -81.9498], "davie||fl": [26.0764, -80.2520],
  "miami beach||fl": [25.7907, -80.1300], "sunrise||fl": [26.1504, -80.2564],
  "plantation||fl": [26.1276, -80.2331], "boca raton||fl": [26.3683, -80.1289],
  "deltona||fl": [28.9005, -81.2637], "alafaya||fl": [28.5402, -81.2092],
  "largo||fl": [27.9095, -82.7873], "deerfield beach||fl": [26.3184, -80.0997],
  "boynton beach||fl": [26.5317, -80.0905], "lauderhill||fl": [26.1401, -80.2130],
  "weston||fl": [26.1003, -80.3998], "homestead||fl": [25.4687, -80.4776],
  "kissimmee||fl": [28.2919, -81.4073], "ocala||fl": [29.1872, -82.1401],
  "fort myers||fl": [26.6406, -81.8723], "pensacola||fl": [30.4213, -87.2169],
  "brandon||fl": [27.9378, -82.2859], "sarasota||fl": [27.3364, -82.5307],
  "daytona beach||fl": [29.2108, -81.0228], "spring hill||fl": [28.4853, -82.5443],
  "clearwater||fl": [27.9659, -82.8001], "north port||fl": [27.0442, -82.2359],
  "melbourne||fl": [28.0836, -80.6081], "doral||fl": [25.8195, -80.3554],
  "tallahassee||fl": [30.4518, -84.2807], "gainesville||fl": [29.6516, -82.3248],
  "jacksonville beach||fl": [30.2947, -81.3932],
  // Georgia
  "atlanta||ga": [33.7490, -84.3880], "columbus||ga": [32.4610, -84.9877],
  "augusta||ga": [33.4735, -82.0105], "macon||ga": [32.8407, -83.6324],
  "savannah||ga": [32.0835, -81.0998], "athens||ga": [33.9519, -83.3576],
  "sandy springs||ga": [33.9248, -84.3743], "roswell||ga": [34.0232, -84.3616],
  "johns creek||ga": [34.0289, -84.1985], "albany||ga": [31.5785, -84.1557],
  "warner robins||ga": [32.6130, -83.5960], "alpharetta||ga": [34.0754, -84.2941],
  "marietta||ga": [33.9526, -84.5499], "valdosta||ga": [30.8327, -83.2785],
  "smyrna||ga": [33.8840, -84.5144], "dunwoody||ga": [33.9462, -84.3346],
  "brookhaven||ga": [33.8651, -84.3365], "gainesville||ga": [34.2979, -83.8241],
  "newnan||ga": [33.3807, -84.7997], "peachtree city||ga": [33.3965, -84.5960],
  // Hawaii
  "honolulu||hi": [21.3069, -157.8583], "east honolulu||hi": [21.2894, -157.7128],
  "pearl city||hi": [21.3972, -157.9745], "hilo||hi": [19.7297, -155.0900],
  "kailua||hi": [21.4022, -157.7394], "waipahu||hi": [21.3861, -158.0097],
  "kaneohe||hi": [21.4181, -157.8003], "mililani town||hi": [21.4499, -158.0141],
  // Idaho
  "boise||id": [43.6150, -116.2023], "nampa||id": [43.5407, -116.5635],
  "meridian||id": [43.6121, -116.3915], "idaho falls||id": [43.4917, -112.0339],
  "pocatello||id": [42.8713, -112.4455], "caldwell||id": [43.6629, -116.6874],
  "coeur d'alene||id": [47.6777, -116.7805], "twin falls||id": [42.5629, -114.4609],
  "lewiston||id": [46.4165, -117.0177], "post falls||id": [47.7182, -116.9516],
  // Illinois
  "chicago||il": [41.8781, -87.6298], "aurora||il": [41.7606, -88.3201],
  "joliet||il": [41.5250, -88.0817], "naperville||il": [41.7508, -88.1535],
  "rockford||il": [42.2711, -89.0940], "springfield||il": [39.7817, -89.6501],
  "elgin||il": [42.0354, -88.2826], "peoria||il": [40.6936, -89.5890],
  "champaign||il": [40.1164, -88.2434], "waukegan||il": [42.3636, -87.8448],
  "cicero||il": [41.8456, -87.7539], "bloomington||il": [40.4842, -88.9937],
  "Arlington heights||il": [42.0884, -87.9806], "evanston||il": [42.0450, -87.6877],
  "decatur||il": [39.8403, -88.9548], "skokie||il": [42.0334, -87.7334],
  "palatine||il": [42.1103, -88.0340], "orland park||il": [41.6303, -87.8540],
  "tinley park||il": [41.5731, -87.7873], "oak lawn||il": [41.7194, -87.7479],
  "berwyn||il": [41.8506, -87.7937], "mount prospect||il": [42.0664, -87.9373],
  "normal||il": [40.5142, -88.9906], "wheaton||il": [41.8661, -88.1070],
  "downers grove||il": [41.8081, -88.0106], "bolingbrook||il": [41.6986, -88.0684],
  "des plaines||il": [42.0334, -87.8834],
  // Indiana
  "indianapolis||in": [39.7684, -86.1581], "fort wayne||in": [41.1306, -85.1289],
  "evansville||in": [37.9716, -87.5711], "south bend||in": [41.6764, -86.2520],
  "carmel||in": [39.9784, -86.1180], "fishers||in": [39.9567, -85.9669],
  "bloomington||in": [39.1653, -86.5264], "hammond||in": [41.5833, -87.5000],
  "gary||in": [41.5934, -87.3465], "muncie||in": [40.1934, -85.3864],
  "lafayette||in": [40.4167, -86.8753], "terre haute||in": [39.4667, -87.4139],
  "kokomo||in": [40.4864, -86.1336], "anderson||in": [40.1053, -85.6803],
  "noblesville||in": [40.0453, -86.0086],
  // Iowa
  "des moines||ia": [41.5868, -93.6250], "cedar rapids||ia": [41.9779, -91.6656],
  "davenport||ia": [41.5236, -90.5776], "sioux city||ia": [42.4999, -96.4003],
  "iowa city||ia": [41.6611, -91.5302], "waterloo||ia": [42.4928, -92.3426],
  "ames||ia": [42.0347, -93.6200], "dubuque||ia": [42.5006, -90.6646],
  "council bluffs||ia": [41.2619, -95.8608], "ankeny||ia": [41.7297, -93.6064],
  "west des moines||ia": [41.5772, -93.7113], "coralville||ia": [41.6670, -91.5835],
  // Kansas
  "wichita||ks": [37.6872, -97.3301], "overland park||ks": [38.9822, -94.6708],
  "kansas city||ks": [39.1155, -94.6268], "olathe||ks": [38.8814, -94.8191],
  "topeka||ks": [39.0558, -95.6890], "lawrence||ks": [38.9717, -95.2353],
  "shawnee||ks": [39.0228, -94.7154], "manhattan||ks": [39.1836, -96.5717],
  "lenexa||ks": [38.9536, -94.7336], "salina||ks": [38.8403, -97.6114],
  // Kentucky
  "louisville||ky": [38.2527, -85.7585], "lexington||ky": [38.0406, -84.5037],
  "bowling green||ky": [36.9685, -86.4808], "owensboro||ky": [37.7719, -87.1112],
  "covington||ky": [39.0837, -84.5086], "richmond||ky": [37.7479, -84.2947],
  "georgetown||ky": [38.2098, -84.5588], "florence||ky": [38.9889, -84.6266],
  "elizabethtown||ky": [37.6940, -85.8591], "hopkinsville||ky": [36.8656, -87.4886],
  // Louisiana
  "new orleans||la": [29.9511, -90.0715], "baton rouge||la": [30.4515, -91.1871],
  "shreveport||la": [32.5252, -93.7502], "metairie||la": [29.9988, -90.1715],
  "lafayette||la": [30.2241, -92.0198], "lake charles||la": [30.2266, -93.2174],
  "kenner||la": [29.9941, -90.2417], "bossier city||la": [32.5160, -93.7321],
  "monroe||la": [32.5093, -92.1193], "alexandria||la": [31.3113, -92.4451],
  // Maine
  "portland||me": [43.6591, -70.2568], "lewiston||me": [44.1003, -70.2148],
  "bangor||me": [44.8012, -68.7778], "south portland||me": [43.6412, -70.2409],
  "auburn||me": [44.0978, -70.2312], "biddeford||me": [43.4926, -70.4534],
  "sanford||me": [43.4395, -70.7748], "saco||me": [43.5009, -70.4428],
  // Maryland
  "baltimore||md": [39.2904, -76.6122], "columbia||md": [39.2037, -76.8610],
  "germantown||md": [39.1732, -77.2717], "silver spring||md": [38.9907, -77.0261],
  "waldorf||md": [38.6251, -76.9186], "glen burnie||md": [39.1626, -76.6269],
  "ellicott city||md": [39.2676, -76.7980], "dundalk||md": [39.2554, -76.5283],
  "rockville||md": [39.0840, -77.1528], "bethesda||md": [38.9807, -77.1000],
  "hagerstown||md": [39.6418, -77.7200], "annapolis||md": [38.9784, -76.4922],
  "bowie||md": [38.9429, -76.7791], "towson||md": [39.4015, -76.6019],
  "gaithersburg||md": [39.1434, -77.2014], "frederick||md": [39.4143, -77.4105],
  // Massachusetts
  "boston||ma": [42.3601, -71.0589], "worcester||ma": [42.2626, -71.8023],
  "springfield||ma": [42.1015, -72.5898], "cambridge||ma": [42.3736, -71.1097],
  "lowell||ma": [42.6334, -71.3162], "brockton||ma": [42.0834, -71.0184],
  "quincy||ma": [42.2529, -71.0023], "lynn||ma": [42.4668, -70.9495],
  "new bedford||ma": [41.6362, -70.9342], "fall river||ma": [41.7015, -71.1550],
  "newton||ma": [42.3370, -71.2092], "somerville||ma": [42.3876, -71.0995],
  "framingham||ma": [42.2793, -71.4162], "taunton||ma": [41.9001, -71.0898],
  "chicopee||ma": [42.1487, -72.6079], "waltham||ma": [42.3765, -71.2356],
  "haverhill||ma": [42.7762, -71.0773], "malden||ma": [42.4251, -71.0662],
  "medford||ma": [42.4184, -71.1062], "peabody||ma": [42.5279, -70.9287],
  // Michigan
  "detroit||mi": [42.3314, -83.0458], "grand rapids||mi": [42.9634, -85.6681],
  "warren||mi": [42.5145, -83.0146], "sterling heights||mi": [42.5803, -83.0302],
  "lansing||mi": [42.7325, -84.5555], "ann arbor||mi": [42.2808, -83.7430],
  "flint||mi": [43.0125, -83.6875], "dearborn||mi": [42.3223, -83.1763],
  "livonia||mi": [42.3684, -83.3527], "clinton township||mi": [42.5873, -82.9196],
  "westland||mi": [42.3245, -83.4002], "troy||mi": [42.6064, -83.1498],
  "farmington hills||mi": [42.4989, -83.3677], "kalamazoo||mi": [42.2917, -85.5872],
  "canton||mi": [42.3087, -83.4827], "pontiac||mi": [42.6389, -83.2911],
  "wyoming||mi": [42.9134, -85.7053], "southfield||mi": [42.4731, -83.2219],
  "muskegon||mi": [43.2342, -86.2484], "saginaw||mi": [43.4195, -83.9508],
  "novi||mi": [42.4808, -83.4755], "rochester hills||mi": [42.6581, -83.1499],
  "taylor||mi": [42.2409, -83.2696],
  // Minnesota
  "minneapolis||mn": [44.9778, -93.2650], "saint paul||mn": [44.9537, -93.0900],
  "rochester||mn": [44.0121, -92.4802], "duluth||mn": [46.7867, -92.1005],
  "bloomington||mn": [44.8408, -93.3477], "brooklyn park||mn": [45.0941, -93.3714],
  "plymouth||mn": [45.0105, -93.4555], "saint cloud||mn": [45.5579, -94.1632],
  "eagan||mn": [44.8041, -93.1669], "woodbury||mn": [44.9239, -92.9594],
  "maple grove||mn": [45.0724, -93.4557], "coon rapids||mn": [45.1197, -93.3078],
  "burnsville||mn": [44.7677, -93.2777], "blaine||mn": [45.1608, -93.2349],
  "lakeville||mn": [44.6497, -93.2428],
  // Mississippi
  "jackson||ms": [32.2988, -90.1848], "gulfport||ms": [30.3674, -89.0928],
  "southaven||ms": [34.9893, -90.0126], "hattiesburg||ms": [31.3271, -89.2903],
  "biloxi||ms": [30.3960, -88.8853], "meridian||ms": [32.3643, -88.7037],
  "tupelo||ms": [34.2576, -88.7029], "greenville||ms": [33.4099, -91.0623],
  "olive branch||ms": [34.9618, -89.8273], "horn lake||ms": [34.9554, -90.0340],
  // Missouri
  "kansas city||mo": [39.0997, -94.5786], "st. louis||mo": [38.6270, -90.1994],
  "springfield||mo": [37.2090, -93.2923], "columbia||mo": [38.9517, -92.3341],
  "independence||mo": [39.0911, -94.4155], "lee's summit||mo": [38.9108, -94.3819],
  "o'fallon||mo": [38.8106, -90.6998], "st. joseph||mo": [39.7675, -94.8467],
  "st. charles||mo": [38.7881, -90.4974], "joplin||mo": [37.0842, -94.5133],
  "blue springs||mo": [39.0169, -94.2816], "chesterfield||mo": [38.6631, -90.5771],
  "florissant||mo": [38.7895, -90.3224], "cape girardeau||mo": [37.3059, -89.5181],
  "jefferson city||mo": [38.5767, -92.1735],
  // Montana
  "billings||mt": [45.7833, -108.5007], "missoula||mt": [46.8721, -113.9940],
  "great falls||mt": [47.5002, -111.3008], "bozeman||mt": [45.6770, -111.0429],
  "butte||mt": [46.0038, -112.5348], "helena||mt": [46.5958, -112.0270],
  "kalispell||mt": [48.1920, -114.3117],
  // Nebraska
  "omaha||ne": [41.2565, -95.9345], "lincoln||ne": [40.8136, -96.7026],
  "bellevue||ne": [41.1370, -95.9146], "grand island||ne": [40.9264, -98.3420],
  "kearney||ne": [40.6993, -99.0817], "fremont||ne": [41.4333, -96.4981],
  "hastings||ne": [40.5862, -98.3884], "north platte||ne": [41.1239, -100.7654],
  "norfolk||ne": [42.0286, -97.4170], "columbus||ne": [41.4300, -97.3687],
  // Nevada
  "las vegas||nv": [36.1699, -115.1398], "henderson||nv": [36.0397, -114.9817],
  "reno||nv": [39.5296, -119.8138], "north las vegas||nv": [36.1989, -115.1175],
  "sparks||nv": [39.5349, -119.7527], "carson city||nv": [39.1638, -119.7674],
  "enterprise||nv": [36.0253, -115.2161], "sunrise manor||nv": [36.2088, -115.0708],
  "spring valley||nv": [36.1081, -115.2403], "whitney||nv": [36.1006, -115.0247],
  "paradise||nv": [36.0872, -115.1484], "boulder city||nv": [35.9786, -114.8328],
  "elko||nv": [40.8324, -115.7631], "mesquite||nv": [36.8049, -114.0671],
  // New Hampshire
  "manchester||nh": [42.9956, -71.4548], "nashua||nh": [42.7654, -71.4676],
  "concord||nh": [43.2081, -71.5376], "derry||nh": [42.8804, -71.3272],
  "dover||nh": [43.1979, -70.8737], "rochester||nh": [43.3040, -70.9748],
  "keene||nh": [42.9334, -72.2779], "portsmouth||nh": [43.0718, -70.7626],
  "laconia||nh": [43.5279, -71.4703],
  // New Jersey
  "newark||nj": [40.7357, -74.1724], "jersey city||nj": [40.7178, -74.0431],
  "paterson||nj": [40.9168, -74.1718], "elizabeth||nj": [40.6640, -74.2107],
  "trenton||nj": [40.2171, -74.7429], "camden||nj": [39.9259, -75.1196],
  "clifton||nj": [40.8584, -74.1638], "passaic||nj": [40.8568, -74.1285],
  "east orange||nj": [40.7673, -74.2049], "union city||nj": [40.7968, -74.0246],
  "vineland||nj": [39.4860, -74.9988], "new brunswick||nj": [40.4862, -74.4518],
  "hackensack||nj": [40.8859, -74.0435], "hoboken||nj": [40.7440, -74.0324],
  "north bergen||nj": [40.7934, -74.0246], "edison||nj": [40.5187, -74.4121],
  "bayonne||nj": [40.6688, -74.1143], "perth amboy||nj": [40.5068, -74.2654],
  "woodbridge||nj": [40.5576, -74.2846], "lakewood||nj": [40.0979, -74.2174],
  // New Mexico
  "albuquerque||nm": [35.0853, -106.6056], "las cruces||nm": [32.3199, -106.7637],
  "rio rancho||nm": [35.2328, -106.6630], "santa fe||nm": [35.6870, -105.9378],
  "roswell||nm": [33.3943, -104.5230], "farmington||nm": [36.7281, -108.2087],
  "south valley||nm": [35.0127, -106.7198], "clovis||nm": [34.4048, -103.2052],
  "hobbs||nm": [32.7026, -103.1360], "alamogordo||nm": [32.8995, -105.9603],
  // New York
  "new york||ny": [40.7128, -74.0060], "buffalo||ny": [42.8864, -78.8784],
  "rochester||ny": [43.1566, -77.6088], "yonkers||ny": [40.9312, -73.8988],
  "syracuse||ny": [43.0481, -76.1474], "albany||ny": [42.6526, -73.7562],
  "new rochelle||ny": [40.9115, -73.7823], "mount vernon||ny": [40.9126, -73.8371],
  "schenectady||ny": [42.8142, -73.9396], "utica||ny": [43.1009, -75.2327],
  "white plains||ny": [41.0340, -73.7629], "hempstead||ny": [40.7062, -73.6187],
  "troy||ny": [42.7284, -73.6918], "levittown||ny": [40.7262, -73.5137],
  "binghamton||ny": [42.0987, -75.9179], "rome||ny": [43.2128, -75.4557],
  "brooklyn||ny": [40.6782, -73.9442], "manhattan||ny": [40.7831, -73.9712],
  "bronx||ny": [40.8448, -73.8648], "queens||ny": [40.7282, -73.7949],
  "staten island||ny": [40.5795, -74.1502], "long island city||ny": [40.7447, -73.9485],
  "flushing||ny": [40.7674, -73.8330], "jamaica||ny": [40.6929, -73.8065],
  // North Carolina
  "charlotte||nc": [35.2271, -80.8431], "raleigh||nc": [35.7796, -78.6382],
  "greensboro||nc": [36.0726, -79.7920], "durham||nc": [35.9940, -78.8986],
  "winston-salem||nc": [36.0999, -80.2442], "fayetteville||nc": [35.0527, -78.8784],
  "cary||nc": [35.7915, -78.7811], "wilmington||nc": [34.2257, -77.9447],
  "high point||nc": [35.9557, -80.0053], "concord||nc": [35.4088, -80.5795],
  "greenville||nc": [35.6127, -77.3663], "asheville||nc": [35.5951, -82.5515],
  "gastonia||nc": [35.2620, -81.1873], "jacksonville||nc": [34.7540, -77.4302],
  "chapel hill||nc": [35.9132, -79.0558], "rocky mount||nc": [35.9382, -77.7905],
  "huntersville||nc": [35.4107, -80.8429], "burlington||nc": [36.0957, -79.4378],
  "apex||nc": [35.7327, -78.8502], "kannapolis||nc": [35.4874, -80.6217],
  "wilson||nc": [35.7215, -77.9155], "monroe||nc": [34.9854, -80.5493],
  "mooresville||nc": [35.5849, -80.8098], "matthews||nc": [35.1193, -80.7178],
  "hickory||nc": [35.7332, -81.3415], "indian trail||nc": [35.0768, -80.6254],
  "salisbury||nc": [35.6710, -80.4742], "new bern||nc": [35.1085, -77.0441],
  // North Dakota
  "fargo||nd": [46.8772, -96.7898], "bismarck||nd": [46.8083, -100.7837],
  "grand forks||nd": [47.9253, -97.0329], "minot||nd": [48.2330, -101.2923],
  "mandan||nd": [46.8269, -100.8896],
  // Ohio
  "columbus||oh": [39.9612, -82.9988], "cleveland||oh": [41.4993, -81.6944],
  "cincinnati||oh": [39.1031, -84.5120], "toledo||oh": [41.6528, -83.5379],
  "akron||oh": [41.0814, -81.5190], "dayton||oh": [39.7589, -84.1916],
  "parma||oh": [41.3845, -81.7229], "canton||oh": [40.7989, -81.3784],
  "youngstown||oh": [41.0998, -80.6495], "lorain||oh": [41.4523, -82.1824],
  "hamilton||oh": [39.3995, -84.5613], "springfield||oh": [39.9242, -83.8088],
  "kettering||oh": [39.6895, -84.1688], "elyria||oh": [41.3684, -82.1074],
  "lakewood||oh": [41.4820, -81.7982], "cuyahoga falls||oh": [41.1334, -81.4846],
  "middletown||oh": [39.5151, -84.3983], "euclid||oh": [41.5931, -81.5268],
  "newark||oh": [40.0584, -82.4013], "mansfield||oh": [40.7584, -82.5155],
  "mentor||oh": [41.6662, -81.3396],
  // Oklahoma
  "oklahoma city||ok": [35.4676, -97.5164], "tulsa||ok": [36.1540, -95.9928],
  "norman||ok": [35.2226, -97.4395], "broken arrow||ok": [36.0526, -95.7908],
  "lawton||ok": [34.6036, -98.3959], "edmond||ok": [35.6528, -97.4781],
  "moore||ok": [35.3395, -97.4867], "midwest city||ok": [35.4495, -97.3967],
  "enid||ok": [36.3956, -97.8784], "stillwater||ok": [36.1156, -97.0584],
  "muskogee||ok": [35.7479, -95.3697], "bartlesville||ok": [36.7473, -95.9807],
  // Oregon
  "portland||or": [45.5051, -122.6750], "salem||or": [44.9429, -123.0351],
  "eugene||or": [44.0521, -123.0868], "gresham||or": [45.5001, -122.4302],
  "hillsboro||or": [45.5229, -122.9898], "beaverton||or": [45.4871, -122.8037],
  "bend||or": [44.0582, -121.3153], "medford||or": [42.3265, -122.8756],
  "springfield||or": [44.0462, -123.0220], "corvallis||or": [44.5646, -123.2620],
  "albany||or": [44.6365, -123.1059], "tigard||or": [45.4312, -122.7710],
  "lake oswego||or": [45.4209, -122.7007], "aloha||or": [45.4871, -122.8671],
  "keizer||or": [44.9901, -123.0262],
  // Pennsylvania
  "philadelphia||pa": [39.9526, -75.1652], "pittsburgh||pa": [40.4406, -79.9959],
  "allentown||pa": [40.6084, -75.4902], "erie||pa": [42.1292, -80.0851],
  "reading||pa": [40.3356, -75.9269], "scranton||pa": [41.4090, -75.6624],
  "bethlehem||pa": [40.6259, -75.3705], "lancaster||pa": [40.0379, -76.3055],
  "harrisburg||pa": [40.2732, -76.8867], "york||pa": [39.9626, -76.7277],
  "altoona||pa": [40.5187, -78.3947], "wilkes-barre||pa": [41.2459, -75.8813],
  "chester||pa": [39.8495, -75.3557], "norristown||pa": [40.1215, -75.3399],
  "state college||pa": [40.7934, -77.8600],
  // Rhode Island
  "providence||ri": [41.8240, -71.4128], "cranston||ri": [41.7798, -71.4373],
  "warwick||ri": [41.7001, -71.4162], "pawtucket||ri": [41.8787, -71.3826],
  "woonsocket||ri": [42.0029, -71.5148], "coventry||ri": [41.6990, -71.5607],
  "north providence||ri": [41.8540, -71.4634],
  // South Carolina
  "columbia||sc": [34.0007, -81.0348], "charleston||sc": [32.7765, -79.9311],
  "north charleston||sc": [32.8546, -79.9748], "mount pleasant||sc": [32.8323, -79.8284],
  "rock hill||sc": [34.9249, -81.0251], "greenville||sc": [34.8526, -82.3940],
  "summerville||sc": [33.0185, -80.1756], "goose creek||sc": [32.9810, -80.0321],
  "hilton head island||sc": [32.2163, -80.7526], "florence||sc": [34.1954, -79.7626],
  "spartanburg||sc": [34.9496, -81.9320], "sumter||sc": [33.9204, -80.3412],
  "myrtle beach||sc": [33.6891, -78.8867], "aiken||sc": [33.5601, -81.7198],
  "anderson||sc": [34.5034, -82.6501],
  // South Dakota
  "sioux falls||sd": [43.5446, -96.7311], "rapid city||sd": [44.0805, -103.2310],
  "aberdeen||sd": [45.4647, -98.4865], "brookings||sd": [44.3114, -96.7984],
  "watertown||sd": [44.8997, -97.1161], "mitchell||sd": [43.7097, -98.0298],
  // Tennessee
  "memphis||tn": [35.1495, -90.0490], "nashville||tn": [36.1627, -86.7816],
  "knoxville||tn": [35.9606, -83.9207], "chattanooga||tn": [35.0456, -85.3097],
  "clarksville||tn": [36.5298, -87.3595], "murfreesboro||tn": [35.8456, -86.3903],
  "franklin||tn": [35.9251, -86.8689], "jackson||tn": [35.6145, -88.8139],
  "johnson city||tn": [36.3134, -82.3535], "bartlett||tn": [35.2045, -89.8742],
  "hendersonville||tn": [36.3048, -86.6200], "kingsport||tn": [36.5484, -82.5618],
  "smyrna||tn": [35.9829, -86.5186], "collierville||tn": [35.0420, -89.6645],
  "brentwood||tn": [36.0331, -86.7827],
  // Texas
  "houston||tx": [29.7604, -95.3698], "san antonio||tx": [29.4241, -98.4936],
  "dallas||tx": [32.7767, -96.7970], "austin||tx": [30.2672, -97.7431],
  "fort worth||tx": [32.7555, -97.3308], "el paso||tx": [31.7619, -106.4850],
  "arlington||tx": [32.7357, -97.1081], "corpus christi||tx": [27.8006, -97.3964],
  "plano||tx": [33.0198, -96.6989], "lubbock||tx": [33.5779, -101.8552],
  "laredo||tx": [27.5306, -99.4803], "garland||tx": [32.9126, -96.6389],
  "irving||tx": [32.8140, -96.9489], "amarillo||tx": [35.2220, -101.8313],
  "grand prairie||tx": [32.7460, -97.0208], "mckinney||tx": [33.1972, -96.6397],
  "frisco||tx": [33.1507, -96.8236], "mesquite||tx": [32.7668, -96.5992],
  "killeen||tx": [31.1171, -97.7278], "mcallen||tx": [26.2034, -98.2300],
  "pasadena||tx": [29.6911, -95.2091], "denton||tx": [33.2148, -97.1331],
  "carrollton||tx": [32.9537, -96.8903], "midland||tx": [31.9974, -102.0779],
  "waco||tx": [31.5493, -97.1467], "round rock||tx": [30.5083, -97.6789],
  "odessa||tx": [31.8457, -102.3676], "abilene||tx": [32.4487, -99.7331],
  "pearland||tx": [29.5635, -95.2860], "richardson||tx": [32.9483, -96.7299],
  "beaumont||tx": [30.0860, -94.1018], "league city||tx": [29.5074, -95.0949],
  "college station||tx": [30.6280, -96.3344], "tyler||tx": [32.3513, -95.3011],
  "sugar land||tx": [29.6197, -95.6349], "allen||tx": [33.1032, -96.6706],
  "wichita falls||tx": [33.9137, -98.4934], "lewisville||tx": [33.0462, -96.9942],
  "edinburg||tx": [26.3017, -98.1633], "san angelo||tx": [31.4638, -100.4370],
  "longview||tx": [32.5007, -94.7405], "cedar park||tx": [30.5052, -97.8203],
  "kyle||tx": [29.9894, -97.8772], "conroe||tx": [30.3119, -95.4561],
  "new braunfels||tx": [29.7030, -98.1245], "brownsville||tx": [25.9017, -97.4975],
  "el paso||tx": [31.7619, -106.4850], "victoria||tx": [28.8053, -97.0036],
  "harlingen||tx": [26.1906, -97.6961], "temple||tx": [31.0982, -97.3428],
  "mission||tx": [26.2159, -98.3253], "pharr||tx": [26.1948, -98.1836],
  "baytown||tx": [29.7355, -94.9774], "missouri city||tx": [29.6188, -95.5380],
  "pflugerville||tx": [30.4393, -97.6200], "mansfield||tx": [32.5632, -97.1416],
  "north richland hills||tx": [32.8343, -97.2290], "burleson||tx": [32.5421, -97.3208],
  "rowlett||tx": [32.9029, -96.5636], "waxahachie||tx": [32.3863, -96.8481],
  "flower mound||tx": [33.0146, -97.0967], "euless||tx": [32.8371, -97.0819],
  "haltom city||tx": [32.7996, -97.2708],
  // Utah
  "salt lake city||ut": [40.7608, -111.8910], "west valley city||ut": [40.6916, -112.0010],
  "provo||ut": [40.2338, -111.6585], "west jordan||ut": [40.6097, -111.9391],
  "orem||ut": [40.2969, -111.6946], "sandy||ut": [40.5649, -111.8389],
  "ogden||ut": [41.2230, -111.9738], "st. george||ut": [37.1041, -113.5841],
  "layton||ut": [41.0602, -111.9711], "taylorsville||ut": [40.6577, -111.9390],
  "south jordan||ut": [40.5621, -111.9297], "lehi||ut": [40.3916, -111.8508],
  "millcreek||ut": [40.6869, -111.8782], "clearfield||ut": [41.1077, -112.0263],
  "murray||ut": [40.6669, -111.8879], "american fork||ut": [40.3769, -111.7958],
  "riverton||ut": [40.5219, -111.9391], "herriman||ut": [40.5138, -112.0326],
  "draper||ut": [40.5246, -111.8635],
  // Vermont
  "burlington||vt": [44.4759, -73.2121], "south burlington||vt": [44.4669, -73.1709],
  "rutland||vt": [43.6106, -72.9726], "essex||vt": [44.4921, -73.0974],
  "colchester||vt": [44.5378, -73.1537],
  // Virginia
  "virginia beach||va": [36.8529, -75.9780], "chesapeake||va": [36.7682, -76.2875],
  "norfolk||va": [36.8508, -76.2859], "richmond||va": [37.5407, -77.4360],
  "newport news||va": [37.0871, -76.4730], "alexandria||va": [38.8048, -77.0469],
  "hampton||va": [37.0299, -76.3452], "portsmouth||va": [36.8354, -76.2983],
  "suffolk||va": [36.7282, -76.5836], "roanoke||va": [37.2710, -79.9414],
  "manassas||va": [38.7509, -77.4753], "lynchburg||va": [37.4138, -79.1423],
  "harrisonburg||va": [38.4496, -78.8689], "charlottesville||va": [38.0293, -78.4767],
  "fredericksburg||va": [38.3032, -77.4605], "danville||va": [36.5860, -79.3950],
  "bristol||va": [36.5951, -82.1885], "arlington||va": [38.8799, -77.1068],
  "falls church||va": [38.8823, -77.1711],
  // Washington
  "seattle||wa": [47.6062, -122.3321], "spokane||wa": [47.6588, -117.4260],
  "tacoma||wa": [47.2529, -122.4443], "vancouver||wa": [45.6387, -122.6615],
  "bellevue||wa": [47.6101, -122.2015], "kent||wa": [47.3809, -122.2348],
  "everett||wa": [47.9790, -122.2021], "renton||wa": [47.4829, -122.2171],
  "spokane valley||wa": [47.6732, -117.2394], "federal way||wa": [47.3223, -122.3126],
  "kirkland||wa": [47.6815, -122.2087], "bellingham||wa": [48.7519, -122.4787],
  "kennewick||wa": [46.2112, -119.1372], "olympia||wa": [47.0379, -122.9007],
  "redmond||wa": [47.6740, -122.1215], "marysville||wa": [48.0518, -122.1771],
  "pasco||wa": [46.2396, -119.1006], "richland||wa": [46.2857, -119.2845],
  "shoreline||wa": [47.7557, -122.3415], "lakewood||wa": [47.1718, -122.5185],
  "sammamish||wa": [47.6163, -122.0356], "burien||wa": [47.4693, -122.3466],
  "south hill||wa": [47.1443, -122.2748], "auburn||wa": [47.3073, -122.2284],
  // West Virginia
  "charleston||wv": [38.3498, -81.6326], "huntington||wv": [38.4193, -82.4452],
  "parkersburg||wv": [39.2667, -81.5615], "morgantown||wv": [39.6295, -79.9559],
  "wheeling||wv": [40.0640, -80.7209], "martinsburg||wv": [39.4562, -77.9639],
  "beckley||wv": [37.7782, -81.1879],
  // Wisconsin
  "milwaukee||wi": [43.0389, -87.9065], "madison||wi": [43.0731, -89.4012],
  "green bay||wi": [44.5133, -88.0133], "kenosha||wi": [42.5847, -87.8212],
  "racine||wi": [42.7261, -87.7829], "appleton||wi": [44.2619, -88.4154],
  "waukesha||wi": [43.0117, -88.2315], "oshkosh||wi": [44.0247, -88.5426],
  "eau claire||wi": [44.8113, -91.4985], "janesville||wi": [42.6828, -89.0187],
  "west allis||wi": [43.0167, -88.0070], "la crosse||wi": [43.8014, -91.2396],
  "sheboygan||wi": [43.7508, -87.7145], "wauwatosa||wi": [43.0497, -88.0070],
  "wausau||wi": [44.9591, -89.6302], "brookfield||wi": [43.0606, -88.1065],
  "beloit||wi": [42.5083, -89.0318], "greenfield||wi": [42.9614, -88.0126],
  // Wyoming
  "cheyenne||wy": [41.1400, -104.8202], "casper||wy": [42.8666, -106.3131],
  "laramie||wy": [41.3114, -105.5911], "gillette||wy": [44.2911, -105.5022],
  "rock springs||wy": [41.5875, -109.2029], "sheridan||wy": [44.7972, -106.9561],
  // Washington DC
  "washington||dc": [38.9072, -77.0369]
};

/**
 * Normalize a state value (full name or abbreviation) to a 2-letter lowercase abbreviation.
 */
function normalizeState(state) {
  if (!state) return null;
  const s = state.trim().toLowerCase();
  if (s.length === 2) return s;
  return STATE_ABBR_MAP[s] || null;
}

/**
 * Geocode a lead's city and state to { lat, lng }.
 * Returns null if the city/state combination is not in the lookup table.
 * Falls back to state centroid if city not found but state is known.
 */
export function geocodeLead(city, state) {
  if (!state) return null;
  const stateAbbr = normalizeState(state);
  if (!stateAbbr) return null;

  if (city) {
    const cityKey = `${city.trim().toLowerCase()}||${stateAbbr}`;
    const coords = CITY_COORDS[cityKey];
    if (coords) return { lat: coords[0], lng: coords[1] };
  }

  // Fall back to state centroid
  const centroid = STATE_CENTROIDS[stateAbbr];
  if (centroid) return { lat: centroid[0], lng: centroid[1] };

  return null;
}

export default CITY_COORDS;
